import React from 'react';
import PropTypes from 'prop-types';

export const MarkdownLink = ({ href, children }) => {
  return (
    <a href={href} data-tracking-id="click_source_link">
      {children}
    </a>
  );
};

MarkdownLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
};
